module.exports = __webpack_public_path__ + "img/docAppointRes_f.d24f166e.png";